import React, { useState } from "react";
import { Card, Button } from "antd";
import { StarFilled, StarOutlined } from "@ant-design/icons";

const PaymentCard = ({ item, billedType, isSelected, onSelect }) => {
  const [showAll, setShowAll] = useState(false);
  const isAnnual = billedType === "annually";
const isEnterprise = item?.name?.toLowerCase() === "enterprise ++";
  const hasPrices = item?.prices?.length > 0;

  const selectedPrice = hasPrices
  ? item.prices.find(p =>
      billedType === "annually" ? p.annualPrice > 0 : p.monthlyPrice > 0
    )
  : null;

const price =
  billedType === "annually"
    ? selectedPrice?.annualPrice
    : selectedPrice?.monthlyPrice;

const planIncludes = [
  { label: "Contracts per country", value: "" },
  { label: "Projects", value: "" },
  { label: "Project managers", value: "" },
  { label: "Team members access", value: "Unlimited" },
  { label: "Guest view", value: "" },
];

// ✅ Only add storage when pricing exists
if (hasPrices) {
  planIncludes.push({
    label: "Storage limit",
    value: `${item.storageLimit} GB`,
  });
}
  const visibleItems = showAll ? planIncludes : planIncludes.slice(0, 3);

  return (
    <Card className={`paymentCard ${isSelected ? "selected" : ""}`}>
      <div className="cardHeader">
        <p className="badge">
          <StarOutlined style={{ fontSize: "24px", color: "#D42177" }} />
        </p>
        <h3>{item?.name}</h3>
      </div>
<div className="priceSection">
  {!hasPrices ? (
    <div className="priceRow">
      <span
        className="price contactPrice"
        style={{ fontSize: "30px", textAlign:"center" }}
      >
        Contact us for pricing
      </span>
    </div>
  ) : (
    <div className="priceRow">
      <span className="currency">USD</span>
      <span className="price">${price}</span>

      <div className="billingInfo">
        <span className="period">
          {billedType === "annually" ? "per year" : "per month"}
        </span>
        {billedType === "annually" && (
          <span className="billed">Billed annually</span>
        )}
      </div>
      
    </div>
  )}
  {item?.name?.toLowerCase() === "professional" && (
    <center>
  <p
    style={{
      color: "#9CA3AF",
      fontSize: "14px",
      marginTop: "8px",
    }}
  >
    One-Time Setup Fee: $5,000 – $7,499
  </p></center>
)}
</div>
      <hr style={{ margin: "0px 20px 20px 20px !important" }}></hr>

      <div className="includes">
        {visibleItems.map((row, index) => (
          <p key={index}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M13.122 8.1252L9.80455 12.5485C9.7508 12.6201 9.6823 12.6793 9.60371 12.7221C9.52505 12.7649 9.43821 12.7904 9.34888 12.7967C9.25963 12.803 9.17004 12.79 9.08621 12.7588C9.00229 12.7274 8.92621 12.6785 8.86288 12.6152L6.87205 10.6252M8.93871 1.13187C9.06604 0.973643 9.22713 0.845967 9.4103 0.758252C9.59346 0.670534 9.79396 0.625 9.99705 0.625C10.2001 0.625 10.4006 0.670534 10.5838 0.758252C10.767 0.845967 10.928 0.973643 11.0554 1.13187L12.3154 2.69937C12.458 2.8772 12.6433 3.01623 12.8539 3.10361C13.0645 3.19099 13.2937 3.22393 13.5204 3.19937L15.5204 2.98187C15.7229 2.95938 15.9278 2.98271 16.12 3.05013C16.3122 3.11757 16.4868 3.22737 16.6309 3.37141C16.7749 3.51545 16.8847 3.69004 16.9521 3.88226C17.0195 4.07448 17.0429 4.27941 17.0204 4.48187L16.8029 6.48187C16.7783 6.70855 16.8112 6.93777 16.8986 7.14837C16.986 7.35897 17.125 7.54416 17.3029 7.68687L18.8704 8.94685C19.0286 9.07418 19.1563 9.23535 19.244 9.41843C19.3317 9.6016 19.3772 9.8021 19.3772 10.0052C19.3772 10.2083 19.3317 10.4088 19.244 10.5919C19.1563 10.7751 19.0286 10.9363 18.8704 11.0635L17.2979 12.3177C17.1201 12.4606 16.9811 12.646 16.8937 12.8567C16.8064 13.0674 16.7734 13.2968 16.7979 13.5235L17.0154 15.5235C17.038 15.726 17.0148 15.931 16.9475 16.1234C16.88 16.3156 16.7703 16.4903 16.6262 16.6343C16.4821 16.7784 16.3075 16.8882 16.1151 16.9556C15.9229 17.0229 15.7179 17.0462 15.5154 17.0235L13.5154 16.806C13.2887 16.7814 13.0595 16.8143 12.8488 16.9017C12.6382 16.9891 12.453 17.1281 12.3104 17.306L11.0554 18.8677C10.9282 19.026 10.767 19.1539 10.5839 19.2417C10.4007 19.3294 10.2002 19.375 9.99705 19.375C9.79396 19.375 9.59338 19.3294 9.41021 19.2417C9.22705 19.1539 9.06596 19.026 8.93871 18.8677L7.67955 17.301C7.53667 17.1232 7.35132 16.9842 7.14059 16.8968C6.92985 16.8094 6.70052 16.7765 6.47371 16.801L4.47371 17.0185C4.27119 17.0413 4.06613 17.0183 3.87376 16.9509C3.68139 16.8836 3.50666 16.7738 3.36254 16.6297C3.21844 16.4856 3.10865 16.3108 3.04133 16.1185C2.97401 15.9261 2.9509 15.721 2.97371 15.5185L3.19121 13.5185C3.21577 13.2918 3.18284 13.0624 3.09545 12.8517C3.00807 12.6409 2.86905 12.4556 2.69121 12.3127L1.12455 11.0535C0.966187 10.9263 0.838395 10.7652 0.750582 10.582C0.662772 10.3989 0.617188 10.1984 0.617188 9.99518C0.617188 9.7921 0.662772 9.59152 0.750582 9.40835C0.838395 9.22518 0.966187 9.0641 1.12455 8.93685L2.69121 7.67687C2.86911 7.53422 3.00818 7.34903 3.09557 7.13841C3.18296 6.9278 3.21585 6.69855 3.19121 6.47187L2.97371 4.47187C2.95106 4.26938 2.97429 4.06438 3.04166 3.87208C3.10903 3.67979 3.21883 3.50513 3.3629 3.36105C3.50698 3.21698 3.68164 3.10718 3.87394 3.03981C4.06623 2.97243 4.27122 2.94921 4.47371 2.97187L6.47371 3.18937C6.70051 3.21383 6.92983 3.18087 7.14055 3.09349C7.35126 3.00612 7.53661 2.86715 7.67955 2.68937L8.93871 1.13187Z"
                stroke="#D42177"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>{" "}
            <strong>{row.value}</strong> {row.label}
          </p>
        ))}

        <span
          className="toggleDetails"
          onClick={() => setShowAll((prev) => !prev)}
        >
          {showAll ? "Show less" : "See all plan details"}
        </span>
      </div>

      <Button
        className="selectBtn"
        type={isSelected ? "primary" : "default"}
        onClick={onSelect}
      >
        {isSelected ? " Plan Selected" : "Select this plan"}
      </Button>
    </Card>
  );
};

export default PaymentCard;
